import React, { useState, useEffect } from 'react';

import ReviewReportDialog from '../modals/ReviewReportDialog';
import commonService from '../../services/commonService';

const ReviewOwnerFooter = (props) => {

    const [reasons, setReasons] = useState("");
    const [dialogIsOpen, setDialogIsOpen] = useState(false);
    const [confirmation, setConfirmation] = useState(false);

    useEffect(() => {
		commonService.getReviewReportReasons()
                .then((res) => {
                    setReasons(res.data.reasons)
                })
	}, []);

    const handleReviewReport = (revId) => {
        setDialogIsOpen(true);
    }

    const handleDialogClose = () => {
	    setDialogIsOpen(false);
        setConfirmation(false);
	}

    return (
        <>
            <div className="reviews-comments-item-footer fl-wrap">
                <div className="reviews-comments-item-date">
                    <span>
                        <i className="far fa-calendar-check"></i>{props.review.created_at}
                    </span>
                </div>
                <button 
                    className="rate-review" 
                    onClick={() => handleReviewReport(props.review.id)}
                >
                    <i className="fal fa-flag"></i> Report Review 
                </button>    
            </div>

            {reasons && props.review && (
                <ReviewReportDialog 
                    dialogIsOpen={dialogIsOpen} 
                    handleDialogClose={handleDialogClose} 
                    setDialogIsOpen={setDialogIsOpen}
                    reviewId={props.review.id}
                    reasons={reasons}
                    confirmation={confirmation} 
                    setConfirmation={setConfirmation}
                    isOwner={true}
                />
            )}
        </>
    );
};

export default ReviewOwnerFooter;